import React from 'react';
import PropTypes from 'prop-types';
// @mui
import {
    Box,
    Checkbox,
    TableRow,
    TableCell,
    TableHead,
    TableSortLabel
} from '@mui/material';

import i18n from '../../../i18n';
import { isFieldVisibleByRole } from '../../../utils/isFieldVisible';

// ----------------------------------------------------------------------

const visuallyHidden = {
    border: 0,
    margin: -1,
    padding: 0,
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    clip: 'rect(0 0 0 0)'
};

GridListHead.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func
};

export default function GridListHead({
    order,
    orderBy,
    rowCount,
    headLabel,
    numSelected,
    onRequestSort,
    onSelectAllClick,
    checkboxCell,
    role
    // rows
}) {
    const createSortHandler = (property) => () => {
        onRequestSort(property);
    };
    const createSortLabel = (field) => {
        if (field.customSort) {
            return field.customSort;
        }
        if (field.show && field.object) {
            return `${field.object}.${field.show}`;
        }
        return field.id;
    };
    // const visibleColumns = getVisibleColumns(headLabel, rows);
    // console.log('visibleColumns', visibleColumns);
    return (
        <TableHead>
            <TableRow>
                {checkboxCell && (
                    <TableCell key="checkbox" padding="checkbox">
                        <Checkbox
                            indeterminate={
                                numSelected > 0 && numSelected < rowCount
                            }
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                )}
                {headLabel
                    .filter((f) => {
                        const fieldKey =
                            f.cell === 'SelectObject' ? f.object : f.id;
                        return (
                            f.displayGrid &&
                            isFieldVisibleByRole(fieldKey, role)
                        );
                    })
                    .map((headCell, index) => {
                        const sortLabel = createSortLabel(headCell);
                        const headCellLabel = headCell.labelCell ? i18n.t(`columns.${headCell.labelCell}`) : i18n.t(`columns.${headCell.label}`);
                        const isFirstCell = index === 0 && !checkboxCell;
                        return (
                            <TableCell
                                key={headCell.id}
                                align={headCell.alignRight ? 'right' : 'left'}
                                sortDirection={
                                    !headCell.disableSort &&
                                    orderBy === sortLabel
                                        ? order
                                        : false
                                }
                                sx={isFirstCell ? { paddingLeft: '24px' } : undefined}
                            >
                                {headCell.disableSort ? (
                                    headCellLabel
                                ) : (
                                    <TableSortLabel
                                        hideSortIcon
                                        active={orderBy === sortLabel}
                                        direction={
                                            orderBy === sortLabel
                                                ? order
                                                : 'asc'
                                        }
                                        onClick={createSortHandler(sortLabel)}
                                    >
                                        {headCellLabel}
                                        {orderBy === sortLabel && (
                                            <Box sx={{ ...visuallyHidden }}>
                                                {order === 'desc'
                                                    ? 'sorted descending'
                                                    : 'sorted ascending'}
                                            </Box>
                                        )}
                                    </TableSortLabel>
                                )}
                            </TableCell>
                        );
                    })}
                <TableCell key="menu"></TableCell>
            </TableRow>
        </TableHead>
    );
}
